import { useState, type ChangeEvent } from 'react';

import { ErrorIcon } from '@/views/Shared/Icons';

type InputType = {
	placeholder?: string;
	name: string;
	id: string;
	autoComplete?: string;
	required: boolean;
	label: string;
	onChange: React.ChangeEventHandler<HTMLInputElement>;
	htmlFor: string;
	type: string;
	ariaLabel: string;
	disabled?: boolean;
	className?: string;
	description?: string | null;
	errorMessage?: string;
};

export default function Input(props: InputType) {
	const {
		placeholder,
		name,
		id,
		autoComplete,
		required,
		label,
		htmlFor,
		onChange,
		type,
		ariaLabel,
		disabled = false,
		className = '',
		description,
		errorMessage,
	} = props;

	const [isActive, setActive] = useState(false);

	const middleWareOnChange = (e: ChangeEvent<HTMLInputElement>) => {
		onChange(e);
		setActive(e.target.value ? true : false);
	};

	const inputTypeModel = {
		id: id,
		placeholder: placeholder,
		name: name,
		autoComplete: autoComplete,
		required: required,
		onChange: middleWareOnChange,
		type: type,
		'aria-label': ariaLabel,
		disabled: disabled,
		className: className,
		description: description,
		errorMessage: errorMessage,
	};
	return (
		<>
			{errorMessage && (
				<p
					className={`mt-1 inline-flex items-center gap-2 text-base text-minos-form-error-color ${
						type === 'date' || type === 'time' ? 'mb-0' : 'mb-3'
					}`}
				>
					<ErrorIcon />
					{errorMessage}
				</p>
			)}
			<div
				className={`relative h-12 w-full ${description ? 'mb-10' : 'mb-5'} ${
					type === 'date' || type === 'time' ? 'mt-6 !w-44' : 'mt-0'
				} `}
			>
				<input
					{...inputTypeModel}
					className={`minos-font peer size-full rounded-minos-form-input border-2 border-minos-form-input-border-color bg-minos-form-input-bg-color p-4 text-base text-minos-form-input-color outline outline-0 transition-all placeholder:opacity-0 focus:border-2 focus:border-minos-form-secondary-color focus:outline-0 focus:placeholder:text-minos-blue_dark-200 focus:placeholder:opacity-100 disabled:cursor-not-allowed disabled:bg-minos-blue_dark-100 ${className} `}
				/>
				<label
					htmlFor={htmlFor}
					className={`peer-placeholder-shown:font-minos-form-font-family pointer-events-none absolute left-4 top-3.5 !overflow-visible truncate text-base transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:text-minos-form-input-color peer-focus:-top-3 peer-focus:rounded-md peer-focus:bg-minos-form-input-bg-color peer-focus:px-1.5 peer-focus:py-1 peer-focus:text-[11px] peer-focus:font-semibold peer-focus:leading-tight peer-focus:text-minos-form-secondary-color peer-disabled:text-transparent ${
						required &&
						'after:ml-0.5 after:font-semibold after:text-minos-form-require-color after:content-["*"]'
					} ${
						isActive || type === 'date' || type === 'time'
							? '!-top-3 rounded-md bg-minos-form-input-bg-color px-1.5 py-1 !text-[11px] leading-tight text-minos-form-input-color'
							: ''
					}`}
				>
					{label}
				</label>
				{description ? (
					<p className='minos-form-content-font-style mt-1 text-base tablet:minos-form-content-font-style'>
						{description}
					</p>
				) : null}
			</div>
		</>
	);
}
